/**
 *  RaceCollision
 *
 *  Created by Legman on 21/03/2017.
 *
 */

/**
 * @class
 * @memberOf race
 */
export default class RaceCollision {
    /**
     * @param {boolean} [left=false]
     * @param {boolean} [right=false]
     * @param {boolean} [top=false]
     * @param {boolean} [bottom=false]
     */
    constructor(left = false, right = false, top = false, bottom = false) {
        /**
         * @member {boolean}
         * @default false
         */
        this.left = left;

        /**
         * @member {boolean}
         * @default false
         */
        this.right = right;

        /**
         * @member {boolean}
         * @default false
         */
        this.top = top;

        /**
         * @member {boolean}
         * @default false
         */
        this.bottom = bottom;
    }
}